const getParam = (paramName) => {
  let paramValue = "", isFound = !1;
  if (window.location.search.indexOf("?") == 0 && window.location.search.indexOf("=") > 1) {
    let arrSource = unescape(window.location.search).substring(1, window.location.search.length).split("&"), i = 0;
    while (i < arrSource.length && !isFound) arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() && (paramValue = arrSource[i].split("=")[1], isFound = !0), i++
  }
  return paramValue == "" && (paramValue = null), paramValue
}

const transformLineBreak = (str) => {
  let transformed = str.replace(/\n/ig, '<br />')
  return transformed
}

const salt = "kImzJHT6HutJQ9d6YrBWBRXB2JHLcw3t";//固定
const prefix = "https://a.app.qq.com/o/simple.jsp?pkgname=com.xizi.quan&android_schema="//固定
const schema = "xiziquan://com.xizi.quan";//固定



/* 
安卓 type
webDetail, webview 
postPublish, 发帖 (对应data应该是fid=1{板块id}&special=10{爆料贴的类型})
personDetail, 个人中心（data是 uid=xxx  跳自己则不带data）
poPublish, 唤起发po （  data是 tag_id=xxx  无话题不带data）
tagDetail 唤起 话题 （ data是 tag_id=xxx  不指定不带data）
channelDetail 唤起栏目 （data是 id=xxx）
forumDetail  唤起板块 （指定板块data是fid=xxx ，否则不带）
livePageDetail 唤醒生活 现同城服务页面
popups 唤醒应用弹窗 
*/

/*
ios
web, webview 
post, 发帖 (对应data应该是fid=1{板块id}&special=10{爆料贴的类型})
user, 个人中心（data是 uid=xxx  跳自己则不带data）
po_post, 唤起发po （  data是 tag_id=xxx  无话题不带data）
po_tag 唤起 话题 （ data是 tag_id=xxx  不指定不带data）
channel 唤起栏目 （data是 id=xxx）
forum  唤起板块 （指定板块data是fid=xxx ，否则不带）
live 唤醒生活 现同城服务页面
popups 唤醒应用弹窗 
*/



const magicLink = (type, data) => {


  const apiMap = {
    web: "webDetail", post: "postPublish", user: "personDetail", po_post: "poPublish",
    po_tag: "poTagDetail", channel: "channelDetail",
    forum: "forumDetail", live: "livePageDetail", popups: "popups", po: "poDetail"
  }

  type = window.OS === 'ios' ? type :  apiMap[type]
  let href = ''
  if (window.OS === 'android') {
    if (type === 'webDetail') {
      const _url = encodeURIComponent(data)
      const hash = md5(data + salt)
      data = `id=${_url}&hash=${hash}`
    }
    const format = `/${type}?${data}`
    href = prefix + encodeURIComponent(schema + format)
  } else {
    href = `https://link.xizi.com/quan_to/${type}${data ? `?${data}` : ''}`
  }
  location.href = href
}


export {
  getParam,
  transformLineBreak,
  magicLink
}



// WEBPACK FOOTER //
// ./src/untils/until.js